import styled from 'styled-components';

import { borderRadius } from '@/theme/selectors';

export const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    padding: 16px;
    background-color: ${({ theme }) => theme['surface-hovered']};
    border-radius: ${borderRadius('medium')};
    margin-top: 16px;
`;

export const Item = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    &:not(:first-child)::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        width: 2px;
        height: 16px;
        transform: translateY(-50%);
        background-color: ${({ theme }) => theme['border-default']};
    }
`;
